import { Fragment, useState, useEffect } from "react";

import MenuItem from "@mui/material/MenuItem";

import MySelectField from "components/Inputs/MySelectField";
import { getVehicles } from "~/services/http/vehicles";

const VehicleSelect = (props) => {
  const { value, updateValues } = props;

  const [vehicles, setVehicles] = useState();

  useEffect(() => {
    getVehicles({}).then((response) => {
      setVehicles([{ id: -1, license_number: "Kaikki" }, ...response]);
    });
  }, []);

  useEffect(() => {
    console.log("value", value);
  }, [value]);

  const handleSelectChange = ({ target }) => {
    updateValues({ [target.name]: target.value });
  };

  return (
    <Fragment>
      <MySelectField
        id="select_vehicle"
        name="car"
        value={value ? value : -1}
        onChange={handleSelectChange}
      >
        {vehicles
          ? vehicles.map((vehicle) => (
              <MenuItem key={vehicle.id} value={vehicle.id}>
                {vehicle.license_number}
              </MenuItem>
            ))
          : null}
      </MySelectField>
    </Fragment>
  );
};

export default VehicleSelect;
